var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-content"},[_c('Affix',{staticStyle:{"widht":"240px"},attrs:{"offset-top":80,"use-capture":""}},[_c('helpMenu')],1),_c('document')],1)}
var staticRenderFns = []

export { render, staticRenderFns }